import styled, { ThemeColor } from 'styled-components'

export const WithColor = styled.span<{ $color?: ThemeColor; $raw?: string }>`
  color: ${({ theme, $color, $raw }) => $raw ?? theme.colors[$color!]};
`
